export const createData = (
  time: string,
  scene: string,
  description: string,
  cast: string,
  location: string
) => ({
  time,
  scene,
  description,
  cast,
  location,
});

export const rowsInitial = () => [
  {
    id: "0",
    time: "",
    scene: "",
    description: "",
    cast: "",
    location: "",
  },
  {
    id: "1",
    time: "",
    scene: "",
    description: "",
    cast: "",
    location: "",
  },
  {
    id: "2",
    time: "",
    scene: "",
    description: "",
    cast: "",
    location: "",
  },
  {
    id: "3",
    time: "",
    scene: "",
    description: "",
    cast: "",
    location: "",
  },
];

export const initialState = [
  {
    id: "0",
    time: "",
    scene: "",
    description: "",
    cast: "",
    location: "",
  },
  {
    id: "1",
    time: "",
    scene: "",
    description: "",
    cast: "",
    location: "",
  },
  {
    id: "2",
    time: "",
    scene: "",
    description: "",
    cast: "",
    location: "",
  },
  {
    id: "3",
    time: "",
    scene: "",
    description: "",
    cast: "",
    location: "",
  },
];
